import { GlLink, GlBadge, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'IssuableStats',
    components: {
        GlLink,
        GlBadge,
        GlSprintf
    },
    props: {
        label: {
            type: String,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        closed: {
            type: Number,
            required: true
        },
        merged: {
            type: Number,
            required: false,
            default: null
        },
        openedPath: {
            type: String,
            required: false,
            default: ''
        },
        closedPath: {
            type: String,
            required: false,
            default: ''
        },
        mergedPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        opened () {
            return this.total - (this.closed + (this.merged || 0));
        },
        showMerged () {
            return this.merged != null;
        }
    }
};
